<template>
  <section class="order">
    <div class="flexClientUser">
      <div class="orderClientWrapper">
        <h2>{{ $t('orderCreate.subHeadings.orderForClient') }}</h2>
        <input
          type="text"
          :placeholder="$t('orderCreate.search')"
          :value="clientSearchInput"
          @input="event => clientSearchInput = event.target.value"
          class="searchInput"
        />
        <ul class="orderSelectButtons">
          <li
            v-for="client in clientsFiltered"
            :key="client.id"
          >
            <OrderSelectButton
              :label="client.name"
              :disabled="!['abg_manager', 'abg_user'].includes(user.role)"
              :selected="isClientSelected(client)"
              :action="() => handleClientChange(client)"
            />
          </li>
        </ul>
        <p>{{ order._errors.client_id }}</p>
      </div>
      <div class="orderClientWrapper">
        <h2>{{ $t('orderCreate.subHeadings.orderForUser') }}</h2>
        <input
          type="text"
          :placeholder="$t('orderCreate.search')"
          :value="clientUserSearchInput"
          @input="event => clientUserSearchInput = event.target.value"
          class="searchInput"
        />
        <ul class="orderSelectButtons">
          <li
            v-for="clientUser in clientUsers"
            :key="clientUser.id"
          >
            <OrderSelectButton
              :label="clientUser.name"
              :disabled="false"
              :selected="isClientUserSelected(clientUser)"
              :action="() => handleClientUserChange(clientUser)"
            />
          </li>
        </ul>
        <p>{{ order._errors.principal_id }}</p>
      </div>
    </div>
    <h2>{{ $t('orderCreate.subHeadings.company') }}</h2>
    <div class="flexClientUser">
      <OrderTextarea
        :label="$t('orderCreate.table.taxNumber')"
        :disabled="false"
        :value="order['tax_number']"
        :input="event => handleChange(event, 'tax_number')"
        :blur="() => handleBlur('tax_number')" 
        :error="getError('tax_number')"
        :rows="1"
        :sizeBig="true"
      />
      <OrderTextarea
        :label="$t('orderCreate.table.companyName')"
        :disabled="false"
        :value="order['company_name']"
        :input="event => handleChange(event, 'company_name')"
        :blur="() => handleBlur('company_name')" 
        :error="getError('company_name')"
        :rows="1"
        :sizeBig="true"
      />
    </div>
    <h2>{{ $t('orderCreate.subHeadings.orderData') }}</h2>
    <div class="flex3">
      <div>
        <h3>{{ $t('orderCreate.subHeadings.principal') }}</h3>
        <OrderTextarea
          :label="$t('orderCreate.table.principalContactPerson')"
          :disabled="false"
          :value="order['principal_contact_person']"
          :input="event => handleChange(event, 'principal_contact_person')"
          :blur="() => handleBlur('principal_contact_person')" 
          :error="getError('principal_contact_person')"
          :rows="2"
        />
        <OrderTextarea
          :label="$t('orderCreate.table.principalPhoneNumber')"
          :disabled="false"
          :value="order['principal_phone_number']"
          :input="event => handleChange(event, 'principal_phone_number')"
          :blur="() => handleBlur('principal_phone_number')" 
          :error="getError('principal_phone_number')"
          :rows="2"
        />
        <OrderTextarea
          :label="$t('orderCreate.table.principalEmailAddress')"
          :disabled="false"
          :value="order['principal_email_address']"
          :input="event => handleChange(event, 'principal_email_address')"
          :blur="() => handleBlur('principal_email_address')" 
          :error="getError('principal_email_address')"
          :rows="2"
        />
      </div>
      <div>
        <h3>{{ $t('orderCreate.subHeadings.customer') }}</h3>
        <OrderTextarea
          :label="$t('orderCreate.table.customerContactPerson')"
          :disabled="false"
          :value="order['customer_contact_person']"
          :input="event => handleChange(event, 'customer_contact_person')"
          :blur="() => handleBlur('customer_contact_person')" 
          :error="getError('customer_contact_person')"
          :rows="2"
        />
        <OrderTextarea
          :label="$t('orderCreate.table.customerPhoneNumber')"
          :disabled="false"
          :value="order['customer_phone_number']"
          :input="event => handleChange(event, 'customer_phone_number')"
          :blur="() => handleBlur('customer_phone_number')" 
          :error="getError('customer_phone_number')"
          :rows="2"
        />
        <OrderTextarea
          :label="$t('orderCreate.table.customerEmailAddress')"
          :disabled="false"
          :value="order['customer_email_address']"
          :input="event => handleChange(event, 'customer_email_address')"
          :blur="() => handleBlur('customer_email_address')" 
          :error="getError('customer_email_address')"
          :rows="2"
        />
        <OrderTextarea
          :label="$t('orderCreate.table.customerAddress')"
          :disabled="false"
          :value="order['customer_address']"
          :input="event => handleChange(event, 'customer_address')"
          :blur="() => handleBlur('customer_address')" 
          :error="getError('customer_address')"
          :rows="2"
        />
      </div>
      <div>
        <h3>{{ $t('orderCreate.subHeadings.subjectOfFinancing') }}</h3>
        <OrderTextarea
          :label="$t('orderCreate.table.subjectOfFinancing')"
          :disabled="false"
          :value="order['subject_of_financing']"
          :input="event => handleChange(event, 'subject_of_financing')"
          :blur="() => handleBlur('subject_of_financing')" 
          :error="getError('subject_of_financing')"
          :rows="2"
        />
        <OrderTextarea
          :label="$t('orderCreate.table.offerValue')"
          :disabled="false"
          :value="order['offer_value']"
          :input="event => handleOfferValueChange(event, 'offer_value')"
          :blur="() => handleBlur('offer_value')" 
          :error="getError('offer_value')"
          :rows="2"
        />
        <OrderTextarea
          :label="$t('orderCreate.table.customerType')"
          :disabled="false"
          :value="order['customer_type']"
          :input="event => handleChange(event, 'customer_type')"
          :blur="() => handleBlur('customer_type')" 
          :error="getError('customer_type')"
          :rows="2"
        />
        <OrderTextarea
          :label="$t('orderCreate.table.transactionType')"
          :disabled="false"
          :value="order['transaction_type']"
          :input="event => handleChange(event, 'transaction_type')"
          :blur="() => handleBlur('transaction_type')" 
          :error="getError('transaction_type')"
          :rows="2"
        />
      </div>
    </div>
    <div class="orderCreate">
      <div>
        <TextIconButton
          :click="() => handleSave()"
          :label="$t('orderCreate.save')"
          :icon="'floppy-disk'"
          :disabled="order._errors.length > 0 || orderSubmitted"
          :spinner="orderSubmitted"
          :sizeBig="true"
        />
      </div>
    </div>
  </section>
</template>

<style scoped>
  .order {
    position: relative;
    padding: 20px;
    font-size: 1.3rem;
    background-color: var(--secondary-background-color);
    border: 2px solid #e9e9e9;
    border-radius: 5px;
    box-shadow: 6px 6px 22px -15px rgba(130, 130, 130, 1);
  }

  .flex3 {
    display: flex;
    flex-wrap: wrap;
  }

  .flex3 > div {
    flex: 1 0 250px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 20px;
  }

  .flexClientUser {
    display: flex;
    flex-wrap: wrap;
  }

  .flexClientUser > div {
    flex: 1 0 33%;
    flex-direction: column;
    display: flex;
    min-width: 250px;
    box-sizing: border-box;
    padding: 20px;
  }

  .flexClientUser > div:nth-child(2) {
    flex: 1 0 66%;
  }

  .orderCreate {
    flex: 0 0 100%;
    padding: 20px;
    text-align: center;
  }

  .orderCreate > div {
    display: inline-block;
    margin: 20px;
  }

  .orderClientWrapper > p {
    margin-top: 0;
    margin-bottom: 10px;
    color: var(--error-color);
  }

  .orderClientWrapper > p:empty::before {
    display: block;
    content: '\00a0';
  }

  .orderSelectButtons {
    max-height: 120px;
    margin: 0;
    padding: 0;
    list-style-type: none;
    overflow: auto;
  }

  .orderSelectButtons > li {
    display: inline-block;
    margin: 5px;
    padding: 0;
  }

  .searchInput {
    margin-bottom: 15px;
    padding: 5px;
    background-color: #fafafa;
    border: none;
    box-shadow: none;
    border-radius: 4px;
    outline: none;
    transition: box-shadow 0.2s;
  }

  .searchInput:focus {
    box-shadow: 0 0 3px 1px rgb(0 0 0 / 10%);
  }
</style>

<script>
  import { validateSingleField, validateAllFields } from '../pages/newOrderValidation.js';
  import OrderSelectButton from './OrderSelectButton.vue';
  import OrderTextarea from './OrderTextarea.vue';
  import TextIconButton from '../buttons/TextIconButton.vue';

  export default {
    components: {
      OrderSelectButton,
      OrderTextarea,
      TextIconButton
    },
    props: [ 'user', 'users', 'clients' ],
    computed: {
      clientsFiltered() {
        return this.clients.filter(client => {
          return client.name.toLowerCase().includes(this.clientSearchInput.toLowerCase());
        });
      },
      clientUsers() {
        return this.users.filter(user => {
          return user.client_id === this.order.client_id
            && user.is_active === 1
            && user.name.toLowerCase().includes(this.clientUserSearchInput.toLowerCase());
        });
      }
    },
    data() {
      return {
        clientSearchInput: '',
        clientUserSearchInput: '',
        orderSubmitted: false, 
        order: {
          _errors: {}
        },
      };
    },
    mounted() {
      if (this.clients.length === 1) {
        this.order.client_id = this.clients[0].id;
      }

      if (this.users.length === 1) {
        this.order.principal_id = this.users[0].id;
        this.order.principal_contact_person = this.users[0].name;
        this.order.principal_email_address = this.users[0].email;
        this.order.principal_phone_number = this.users[0].phone_number;
      }
    },
    methods: {
      getError(key) {
        if (this.order._errors.hasOwnProperty(key)) {
          return this.order._errors[key];
        }
        
        return '';
      },
      handleClientChange(client) {
        if (this.order.client_id === client.id) {
          return;
        }

        this.order.client_id = client.id;
        this.clientUserSearchInput = '';
        this.order.principal_id = null;
        this.order.principal_contact_person = null;
        this.order.principal_email_address = null;
        this.order.principal_phone_number = null;
        this.validateField('client_id');
      },
      isClientSelected(client) {
        return this.order.client_id === client.id;
      },
      handleClientUserChange(clientUser) {
        this.order.principal_id = clientUser.id;
        this.order.principal_contact_person = clientUser.name ?? '';
        this.order.principal_email_address = clientUser.email ?? '';
        this.order.principal_phone_number = clientUser.phone_number ?? '';
        this.validateField('principal_id');
        this.validateField('principal_contact_person');
        this.validateField('principal_email_address');
        this.validateField('principal_phone_number');
      },
      isClientUserSelected(clientUser) {
        return this.order.principal_id === clientUser.id;
      },
      handleOfferValueChange(event, key) {
        event.target.value = event.target.value.replace(/[^\d\.,]/g, '');
        event.target.value = event.target.value.replace(/^[\.,]/g, '');

        ['.', ','].forEach(char => {
          const firstOccurence = event.target.value.indexOf(char);

          if (firstOccurence !== -1) {
            event.target.value = event.target.value.replace(/[\.,]/g, (c, i) => i > firstOccurence ? '' : c);
            event.target.value = event.target.value.slice(0, firstOccurence + 3);
          }
        });

        if (this.order[key] === event.target.value) {
          return;
        }

        this.handleChange(event, key);
      },
      handleChange(event, key) {
        this.order[key] = event.target.value;

        const currentError = this.getError(key);

        if (currentError.length > 0) {
          const message = validateSingleField(this.order, key);

          if (message.length > 0) {
            this.order._errors[key] = message;
          } else {
            delete this.order._errors[key];
          }
        }
      },
      handleBlur(key) {
        this.validateField(key);
      },
      validateField(key) {
        const message = validateSingleField(this.order, key);
  
        if (message.length > 0) {
          const currentError = this.getError(key);
  
          if (currentError !== message) {
            this.order._errors[key] = message;
          }
        } else {
          delete this.order._errors[key];
        }

        this.$forceUpdate();
      },
      validateForm() {
        const errors = validateAllFields(this.order);
        this.order._errors = errors;

        if (Object.keys(errors).length > 0) {
          return false;
        }

        return true;
      },
      normalizeOfferValue() {
        let value = this.order.offer_value;
        const pos = Math.max(value.indexOf('.'), value.indexOf(','));

        if (pos === -1 || pos === value.length -1) {
          value += '00';
        } else if (pos === value.length -2) {
          value += '0';
        } else {
          value = value.slice(0, pos + 3);
        }

        return value.replace(/[\.,]/g, '');
      },
      handleSave: async function () {
        this.orderSubmitted = true;
        const validation = this.validateForm(this.order);
        
        if (!validation) {
          this.orderSubmitted = false;
          return;
        }

        const formattedOrder = {
          ...this.order,
          offer_value: this.normalizeOfferValue(),
          status: 'new',
          source: 'web'
        };

        const response = await fetch('/api/order', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formattedOrder)
        });

        const responseJson = await response.json();

        if (!response.ok || isNaN(responseJson.id)) {
          for (const [key, value] of Object.entries(responseJson)) {
            this.order._errors[key] = value.join('; ');
          }

          this.orderSubmitted = false;
          this.$forceUpdate();
          return;
        }

        window.location.href = `/zgloszenie/${responseJson.id}`;
      }
    }
  }
</script>
